/**
 * @generated SignedSource<<efc535b4ad36fdb7dd0f9ff06fd38c2b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GraphStoreAtlasHomeSourcesEnum = "JIRA_EPIC_WITHOUT_PROJECT" | "JIRA_ISSUE_ASSIGNED" | "JIRA_ISSUE_NEAR_OVERDUE" | "JIRA_ISSUE_OVERDUE" | "USER_JOIN_FIRST_TEAM" | "USER_PAGE_NOT_VIEWED_BY_OTHERS" | "USER_SHOULD_FOLLOW_GOAL" | "USER_SHOULD_VIEW_SHARED_PAGE" | "USER_VIEW_ASSIGNED_ISSUE" | "USER_VIEW_NEGATIVE_GOAL" | "USER_VIEW_NEGATIVE_PROJECT" | "USER_VIEW_PAGE_COMMENTS" | "USER_VIEW_SHARED_VIDEO" | "USER_VIEW_TAGGED_VIDEO_COMMENT" | "USER_VIEW_UPDATED_GOAL" | "USER_VIEW_UPDATED_PRIORITY_ISSUE" | "USER_VIEW_UPDATED_PROJECT";
export type WorkFeedSectionQuery$variables = {
  containerIds: ReadonlyArray<string>;
  enabledSources: ReadonlyArray<GraphStoreAtlasHomeSourcesEnum>;
  isEnabled: boolean;
};
export type WorkFeedSectionQuery$data = {
  readonly graphStore?: {
    readonly atlasHomeFeed: {
      readonly " $fragmentSpreads": FragmentRefs<"WorkFeedItems">;
    };
  } | null;
};
export type WorkFeedSectionQuery = {
  response: WorkFeedSectionQuery$data;
  variables: WorkFeedSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enabledSources"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEnabled"
},
v3 = [
  {
    "kind": "Variable",
    "name": "container_ids",
    "variableName": "containerIds"
  },
  {
    "kind": "Variable",
    "name": "enabled_sources",
    "variableName": "enabledSources"
  },
  {
    "kind": "Literal",
    "name": "ranking_criteria",
    "value": {
      "criteria": "ROUND_ROBIN_RANDOM",
      "limit": 15
    }
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = [
  (v7/*: any*/),
  (v5/*: any*/)
],
v9 = [
  (v5/*: any*/)
],
v10 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v11 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "ConfluenceBlogPost"
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "ConfluenceFooterComment"
},
v13 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "ConfluenceInlineComment"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "webUi"
  },
  {
    "kind": "ScalarField",
    "name": "base"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v16 = {
  "kind": "ScalarField",
  "name": "url"
},
v17 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v18 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v19 = [
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v20 = [
  (v5/*: any*/),
  (v7/*: any*/),
  (v16/*: any*/),
  (v15/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v22 = [
  (v4/*: any*/),
  (v21/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "WorkFeedSectionQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "GraphStoreAtlasHomeQueryConnection",
                "kind": "LinkedField",
                "name": "atlasHomeFeed",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "WorkFeedItems"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkFeedSectionQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "GraphStoreAtlasHomeQueryConnection",
                "kind": "LinkedField",
                "name": "atlasHomeFeed",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreAtlasHomeQueryNode",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "source"
                      },
                      {
                        "concreteType": "GraphStoreAtlasHomeQueryItem",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "summary"
                                  },
                                  {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": (v8/*: any*/)
                                      },
                                      (v5/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v6/*: any*/),
                                          (v5/*: any*/)
                                        ]
                                      },
                                      (v5/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "key"
                                  },
                                  {
                                    "concreteType": "JiraPriorityField",
                                    "kind": "LinkedField",
                                    "name": "priorityField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "priority",
                                        "plural": false,
                                        "selections": (v8/*: any*/)
                                      },
                                      (v5/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "JiraIssue"
                              },
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "title"
                                  },
                                  {
                                    "concreteType": "ConfluencePageLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v14/*: any*/)
                                  },
                                  {
                                    "concreteType": "ConfluenceSpace",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "concreteType": "ConfluenceSpaceLinks",
                                        "kind": "LinkedField",
                                        "name": "links",
                                        "plural": false,
                                        "selections": (v14/*: any*/)
                                      },
                                      (v5/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ConfluencePage"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "goalId",
                                    "kind": "ScalarField",
                                    "name": "id"
                                  },
                                  {
                                    "alias": "goalName",
                                    "kind": "ScalarField",
                                    "name": "name"
                                  },
                                  {
                                    "alias": "goalUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "isWatching"
                                  },
                                  (v15/*: any*/)
                                ],
                                "type": "TownsquareGoal"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "concreteType": "TownsquareGoalState",
                                    "kind": "LinkedField",
                                    "name": "newState",
                                    "plural": false,
                                    "selections": (v19/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": (v20/*: any*/)
                                  }
                                ],
                                "type": "TownsquareGoalUpdate"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "concreteType": "TownsquareProjectState",
                                    "kind": "LinkedField",
                                    "name": "newState",
                                    "plural": false,
                                    "selections": (v19/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": (v20/*: any*/)
                                  }
                                ],
                                "type": "TownsquareProjectUpdate"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": "videoUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  },
                                  (v15/*: any*/),
                                  {
                                    "alias": "loomOwner",
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": (v22/*: any*/)
                                  }
                                ],
                                "type": "LoomVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "LoomVideo",
                                    "kind": "LinkedField",
                                    "name": "video",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v7/*: any*/),
                                      (v16/*: any*/),
                                      (v15/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "owner",
                                        "plural": false,
                                        "selections": (v22/*: any*/)
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v21/*: any*/),
                                      (v7/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "createdAt"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "editedAt"
                                  }
                                ],
                                "type": "LoomComment"
                              }
                            ]
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "GraphStoreAtlasHomeQueryMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                  }
                                ],
                                "type": "TeamV2"
                              },
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "ConfluencePage"
                              }
                            ]
                          },
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "879ca8bbfdd20d9d581e6b05ee87adee",
    "id": null,
    "metadata": {},
    "name": "WorkFeedSectionQuery",
    "operationKind": "query",
    "text": "query WorkFeedSectionQuery(\n  $containerIds: [ID!]!\n  $isEnabled: Boolean!\n  $enabledSources: [GraphStoreAtlasHomeSourcesEnum!]!\n) {\n  graphStore @include(if: $isEnabled) @optIn(to: [\"GraphStore\", \"GraphStoreAtlasHomeFeed\"]) {\n    atlasHomeFeed(container_ids: $containerIds, enabled_sources: $enabledSources, ranking_criteria: {criteria: ROUND_ROBIN_RANDOM, limit: 15}) {\n      ...WorkFeedItems\n    }\n  }\n}\n\nfragment FollowGoalItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on TownsquareGoal {\n        goalId: id\n        goalName: name\n        goalUrl: url\n        isWatching\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n  metadata {\n    data {\n      __typename\n      ... on TeamV2 {\n        id\n        displayName\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment JiraEpicWithoutProjectItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on JiraIssue {\n        id\n        webUrl\n        summary\n        key\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment JiraIssueNearOverdueItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on JiraIssue {\n        id\n        webUrl\n        summary\n        issueTypeField {\n          issueType {\n            name\n            id\n          }\n          id\n        }\n        projectField {\n          project {\n            name\n            webUrl\n            id\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment JiraIssueOverdueItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on JiraIssue {\n        id\n        webUrl\n        summary\n        issueTypeField {\n          issueType {\n            name\n            id\n          }\n          id\n        }\n        projectField {\n          project {\n            name\n            webUrl\n            id\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment JiraIssuePriorityUpdatedItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on JiraIssue {\n        id\n        webUrl\n        summary\n        issueTypeField {\n          issueType {\n            name\n            id\n          }\n          id\n        }\n        priorityField {\n          priority {\n            name\n            id\n          }\n          id\n        }\n        projectField {\n          project {\n            name\n            webUrl\n            id\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment JiraIssueViewAssignedItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on JiraIssue {\n        id\n        webUrl\n        summary\n        issueTypeField {\n          issueType {\n            name\n            id\n          }\n          id\n        }\n        projectField {\n          project {\n            name\n            webUrl\n            id\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ReviewGoalUpdateItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on TownsquareGoalUpdate {\n        url\n        creationDate\n        editDate\n        newState {\n          label\n        }\n        goal {\n          id\n          name\n          url\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ReviewProjectUpdateItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on TownsquareProjectUpdate {\n        url\n        creationDate\n        editDate\n        newState {\n          label\n        }\n        project {\n          id\n          name\n          url\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ShareConfluencePageItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on ConfluencePage {\n        id\n        title\n        links {\n          webUi\n          base\n        }\n        space {\n          name\n          links {\n            webUi\n            base\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ViewConfluencePageItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on ConfluencePage {\n        id\n        title\n        links {\n          webUi\n          base\n        }\n        space {\n          name\n          links {\n            webUi\n            base\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ViewSharedVideoItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on LoomVideo {\n        id\n        name\n        videoUrl: url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ViewTaggedVideoCommentItem on GraphStoreAtlasHomeQueryNode {\n  item {\n    data {\n      __typename\n      ... on LoomComment {\n        video {\n          id\n          name\n          url\n        }\n        user {\n          __typename\n          accountId\n          name\n          id\n        }\n        createdAt\n        editedAt\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on ConfluenceBlogPost {\n        id\n      }\n      ... on ConfluenceFooterComment {\n        id\n      }\n      ... on ConfluenceInlineComment {\n        id\n      }\n      ... on ConfluencePage {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment WorkFeedItems on GraphStoreAtlasHomeQueryConnection {\n  nodes {\n    source\n    ...JiraIssueOverdueItem\n    ...JiraIssueNearOverdueItem\n    ...JiraEpicWithoutProjectItem\n    ...JiraIssuePriorityUpdatedItem\n    ...JiraIssueViewAssignedItem\n    ...FollowGoalItem\n    ...ReviewGoalUpdateItem\n    ...ReviewProjectUpdateItem\n    ...ShareConfluencePageItem\n    ...ViewConfluencePageItem\n    ...ViewSharedVideoItem\n    ...ViewTaggedVideoCommentItem\n    item {\n      data {\n        __typename\n        ... on TownsquareGoalUpdate {\n          goal {\n            isArchived\n            id\n          }\n        }\n        ... on TownsquareProjectUpdate {\n          project {\n            isArchived\n            id\n          }\n        }\n        ... on TownsquareGoal {\n          isArchived\n        }\n        ... on LoomVideo {\n          isArchived\n          loomOwner: owner {\n            __typename\n            accountId\n            id\n          }\n        }\n        ... on LoomComment {\n          video {\n            isArchived\n            owner {\n              __typename\n              accountId\n              id\n            }\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on ConfluenceBlogPost {\n          id\n        }\n        ... on ConfluenceFooterComment {\n          id\n        }\n        ... on ConfluenceInlineComment {\n          id\n        }\n        ... on ConfluencePage {\n          id\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "12f68d08d4c9aee15584e0076f625557";

export default node;
